<template>
  <ElementLayout>
    <!-- @vue-ignore -->
    <template #element>
      <!-- @vue-ignore -->
      <template v-if="typeof (items || [])[0] === 'string'">
        <!-- @vue-ignore -->
        <v-combobox
          v-model="selection"
          v-model:search="search"
          density="compact"
          class="vueform-combobox"
          ref="customCombobox"
          :items="items"
          hide-details
          multiple
          chips
          @blur="onBlur"
          @update:model-value="onSelectionChange"
        >
          <template v-slot:item="{ props, item }">
            <v-list-item
              v-bind="props"
            >
              <template v-slot:prepend="{ isActive }">
                <v-list-item-action start>
                  <v-checkbox-btn :model-value="isActive"></v-checkbox-btn>
                </v-list-item-action>
              </template>
            </v-list-item>
          </template>
        </v-combobox>
      </template>
      <!-- @vue-ignore -->
      <template v-else>
        <!-- @vue-ignore -->
        <v-combobox
          v-model="selection"
          v-model:search="search"
          density="compact"
          class="vueform-combobox"
          ref="customCombobox"
          :items="items"
          item-title="label"
          :custom-filter="customFilter"
          hide-details
          multiple
          chips
          return-object
          @blur="onBlur"
          @update:model-value="onSelectionChange"
        >
          <template v-slot:item="{ props, item }">
            <v-list-item
              v-bind="props"
            >
              <template v-slot:prepend="{ isActive }">
                <v-list-item-action start>
                  <v-checkbox-btn :model-value="isActive"></v-checkbox-btn>
                </v-list-item-action>
              </template>
            </v-list-item>
          </template>
        </v-combobox>
      </template>
    </template>
  </ElementLayout>
</template>

<script lang="ts">
import { defineElement } from '@vueform/vueform'
import { customAccountabilityFilter } from '@/utils/accountability_filters'

interface ObjectItem {
  value: string | number
  label: string,
  code?: string
}
interface Element {
  value: string[] | ObjectItem[]
  update: Function
}
interface Attrs {
  items: string[] | ObjectItem[]
}
interface Context {
  element: Element
  attrs: Attrs
}

export default defineElement({
  name: 'CustomMultiSelectElement',
  nullValue: [],
  setup(props: Object, { element, attrs }: Context) {
    const { value, update } = element
    const { items } = attrs
    return { value, items, update }
  },
  data() {
    return {
      search: "",
      // @ts-ignore - value is set by watcher with immediate: true
      selection: [] as string[] | ObjectItem[]
    }
  },
  methods: {
    onSelectionChange(newSelection: string[] | ObjectItem[]) {
      // @ts-ignore
      this.update(newSelection || [])
    },
    onBlur() {
      // @ts-ignore
      this.search = ''
      // @ts-ignore
      this.$refs.customCombobox.search = ""
    },
    customFilter: customAccountabilityFilter,
  },
  watch: {
    value: {
      handler(newVal: string[] | ObjectItem[]) {
        // @ts-ignore
        this.selection = [...(newVal || [])]
      },
      immediate: true,
      deep: true
    }
  }
})
</script>
